import antonioPic from "@/public/images/artists/antonio.png";
import { Artist } from "@/types/types";

export const antonio = {
  id: "227",
  name: "Antonio",
  image: antonioPic,
  description: `Antonio's voice has a dense, robust quality, and an earthy tone that carries both warmth and weight. His range combines intensity with subtlety, ideal for the emotional demands of opera.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fantonio-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Unprocessed", "Classical"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 46,
        high: 70,
      },
      sweetSpot: 58,
    },
  },
} as const satisfies Artist;
